import { Component, OnInit, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { MasterService } from "../../services/master.service";
import { SharedService } from "src/app/shared.service";
import { GlobalService } from "../../services/global.service";
import { debounceTime, distinctUntilChanged, map, takeUntil } from "rxjs/operators";
import { forkJoin } from "rxjs";

type AdminServiceTabId = "all" | "booking" | "maintenance" | "internal" | "hygiene";
import {
  ServiceResponseArrayModel,
  ServiceResponseModel
} from "../../models/common-request-response";
import { UntypedFormControl } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { JwtService } from "../../services/jwt.service";
import { ConfirmationPopupComponent } from "../../modals/confirmation-popup/confirmation-popup.component";
import { MatDialog } from "@angular/material/dialog";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";

@Component({
  selector: "app-hotel-services",
  templateUrl: "./hotel-services.component.html",
  styleUrls: ["./hotel-services.component.scss"]
})
export class HotelServicesComponent implements OnInit {
  private readonly serviceAdminTabStorageKey = "serviceAdminSelectedTabV2";
  private readonly serviceAdminTabStorageKeyLegacy = "serviceAdminSelectedTab";
  private readonly serviceAdminForceTabStorageKey = "serviceAdminForceTab";
  private readonly adminServiceTabOrder: AdminServiceTabId[] = [
    "all",
    "booking",
    "maintenance",
    "internal",
    "hygiene"
  ];
  public selectedAdminTabId: AdminServiceTabId = "booking";
  public adminTabVisibility: Record<AdminServiceTabId, boolean> = {
    all: true,
    booking: true,
    maintenance: true,
    internal: true,
    hygiene: true
  };
  headerLangHotelChangeEvent$;
  public serviceResponseArrayModel: ServiceResponseArrayModel = new ServiceResponseArrayModel();
  public ServiceResponseModel: ServiceResponseModel = new ServiceResponseModel();
  @Input() serviceLocationStatus: string;
  @Output() detailServiceViewEmit = new EventEmitter();
  @Output() editServiceViewEmit = new EventEmitter();
  @Output() checkServiceCount = new EventEmitter();
  @Input() serviceType: number;
  @Input() selectedCategory: string | null = null;
  innerBannerShow: boolean = false;
  thresholdServiceId;
  viewAllShow: boolean = true;
  headdingTitle = this.translate.instant("HotelRestuarants");
  length = 0;
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  currentPageSize;
  // MatPaginator Output
  pageEvent: PageEvent;
isToggleChecked = false;
  //Loader
  title = "materialApp";
  color = "primary";
  mode = "indeterminate";
  showLoader: boolean = true;
  public searchControl: UntypedFormControl;
  public servicesList;
  public selectedServiceTabIndex: number = 0;
  public frontView = "view";
  public isLoggedIn: boolean;
  userRoleRoute: string = '';
  @ViewChild('paginator') paginator: MatPaginator;
  public categories: any[] = [];
  public totalServiceCount: number = 0;
  private guestCategoryFilterTouched = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private masterService: MasterService,
    private sharedService: SharedService,
    public globalService: GlobalService,
    public translate: TranslateService,
    private jwtService: JwtService,
    private dialog: MatDialog
  ) {
    this.userRoleRoute = `/portal/${this.jwtService.getUserRole()}/Dashboard-Service-List`;
    this.isLoggedIn = this.globalService.hasCheckInAuthToken();
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(",").map(str => +str);
  }

  ngOnInit() {
    const requestedTabIndex = this.parseTabIndex(this.route.snapshot.queryParamMap.get("tab"));
    const forcedTabIndex = this.parseTabIndex(sessionStorage.getItem(this.serviceAdminForceTabStorageKey));
    if (this.serviceLocationStatus === "serviceAdminView") {
      const adminTabMax = 4;
      let tabIndex = 1;
      if (forcedTabIndex !== null) {
        tabIndex = Math.max(0, Math.min(adminTabMax, forcedTabIndex));
        sessionStorage.removeItem(this.serviceAdminForceTabStorageKey);
      } else if (requestedTabIndex !== null) {
        tabIndex = Math.max(0, Math.min(adminTabMax, requestedTabIndex));
      } else {
        const storedV2 = this.parseTabIndex(sessionStorage.getItem(this.serviceAdminTabStorageKey));
        if (storedV2 !== null) {
          tabIndex = Math.max(0, Math.min(adminTabMax, storedV2));
        } else {
          const legacyTab = this.parseTabIndex(
            sessionStorage.getItem(this.serviceAdminTabStorageKeyLegacy)
          );
          if (legacyTab !== null) {
            tabIndex = Math.min(adminTabMax, legacyTab + 1);
            sessionStorage.setItem(this.serviceAdminTabStorageKey, String(tabIndex));
            sessionStorage.removeItem(this.serviceAdminTabStorageKeyLegacy);
          }
        }
      }
      this.selectedAdminTabId = this.adminTabIdFromIndex(tabIndex);
      this.selectedServiceTabIndex = tabIndex;
    }

    // API Requests For Different Locations
    if (
      this.serviceLocationStatus == "home" ||
      this.serviceLocationStatus == "homePageMenu"
    ) {
      this.globalService.showLoader = false;
      this.showServiceLists({
        Data: "home",
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      });
    }

    if (this.serviceLocationStatus == "serviceFrontView" || this.serviceLocationStatus == "serviceAdminView") {
      this.searchControl = new UntypedFormControl();

      this.searchControl.valueChanges
        .pipe(
          debounceTime(400),
          distinctUntilChanged(),
          takeUntil(this.globalService.componentDestroyed(this))
        )
        .subscribe(result => {
          this.pageIndex = 0;
          const tabRequest = this.getTabRequestContext();
          this.showServiceLists({
            Data: tabRequest.Data,
            ServiceType: tabRequest.ServiceType,
            InternalService: tabRequest.InternalService,
            Search: result,
            pageIndex: 0,
            pageSize: this.pageSize,
            isLoggedIn: this.isLoggedIn
          });
        });

      if (
        this.serviceLocationStatus === "serviceFrontView" ||
        this.serviceLocationStatus === "serviceAdminView"
      ) {
        this.loadCategories(() => {
          this.refreshAdminServiceTabs(() => {
            const tabRequest = this.getTabRequestContext();
            this.showServiceLists({
              Data: tabRequest.Data,
              ServiceType: tabRequest.ServiceType,
              InternalService: tabRequest.InternalService,
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              isLoggedIn: this.isLoggedIn
            });
          });
        });
      } else {
        const tabRequest = this.getTabRequestContext();
        this.showServiceLists({
          Data: tabRequest.Data,
          ServiceType: tabRequest.ServiceType,
          InternalService: tabRequest.InternalService,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          isLoggedIn: this.isLoggedIn
        });
      }
    }



    this.headerLangHotelChangeEvent$ = this.sharedService.headerLangChangeEvent.subscribe(
      (data: string) => {
        // API Requests For Different Locations
        if (this.serviceLocationStatus == "home") {
          this.showServiceLists({
            Data: "home",
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          });
        }

        if (this.serviceLocationStatus == "serviceFrontView" || this.serviceLocationStatus == "serviceAdminView") {
          if (
            this.serviceLocationStatus === "serviceFrontView" ||
            this.serviceLocationStatus === "serviceAdminView"
          ) {
            this.loadCategories(() => {
              this.refreshAdminServiceTabs(() => {
                const tabRequest = this.getTabRequestContext();
                this.showServiceLists({
                  Data: tabRequest.Data,
                  ServiceType: tabRequest.ServiceType,
                  InternalService: tabRequest.InternalService,
                  pageIndex: this.pageIndex,
                  pageSize: this.pageSize,
                  isLoggedIn: this.isLoggedIn,
                  Search: this.searchControl?.value || ""
                });
              });
            });
          } else {
            const tabRequest = this.getTabRequestContext();
            this.showServiceLists({
              Data: tabRequest.Data,
              ServiceType: tabRequest.ServiceType,
              InternalService: tabRequest.InternalService,
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              isLoggedIn: this.isLoggedIn
            });
          }
        }

        if (this.serviceLocationStatus == "serviceManagePage") {

          this.showServiceLists({
            Data: null,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            ServiceType: this.serviceType
          });
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.headerLangHotelChangeEvent$) {
      this.headerLangHotelChangeEvent$.unsubscribe();
    }
  }
  ngOnChanges() {
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.pageIndex = 0;
    }


    const currentPageSize = this.currentPageSize || this.pageSize;

    // Whenever inputs change, fetch the services list based on the new filters
    if (this.serviceLocationStatus == "serviceManagePage") {
      this.showServiceLists({
        ServiceType: this.serviceType,
        pageIndex: 0,
        pageSize: currentPageSize,
        Data: "serviceManagePage"
      });
    }
  }

  showServiceLists(data) {

    data.serviceLocationStatus = this.serviceLocationStatus;
    this.globalService.showLoader = true;
    const isAdminPortalRoute = this.router.url && this.router.url.includes("/portal");
    const useAdminServiceListApi =
      isAdminPortalRoute ||
      this.serviceLocationStatus == "serviceManagePage" ||
      this.serviceLocationStatus == "serviceAdminView";

    if (this.serviceLocationStatus === "serviceManagePage") {
      data.categoryId = this.selectedCategory;
    } else if (this.selectedCategory) {
      data.categoryId = this.selectedCategory;
    }
    if (!useAdminServiceListApi) {
      if (this.serviceLocationStatus == "serviceAdminView") {
        this.globalService.showLoader = true;
      } else {
        this.globalService.showLoader = true;
      }
      this.masterService
        .showServiceLists(data)
        .pipe(takeUntil(this.globalService.componentDestroyed(this)))
        .subscribe(
          response => {
            if (response.Status) {
              if (this.serviceLocationStatus !== "serviceAdminView") {
                for (let i = 0; i < response.Data.ServiceLists.length; i++) {
                  if (response.Data.ServiceLists[i].InternalService) {
                    response.Data.ServiceLists.splice(i, 1);
                  }
                }
              }
              if (this.serviceLocationStatus == "homePageMenu") {
                response.Data.ServiceLists = response.Data.ServiceLists.filter(service => service.ShowOnHomePage);
              }
              this.serviceResponseArrayModel = this.globalService.jsonConvert.deserializeObject(
                response.Data,
                ServiceResponseArrayModel
              );

              this.length =
                response.Data?.CountLists ||
                response.Data?.TotalCount ||
                this.serviceResponseArrayModel?.ServiceLists?.length ||
                0;

              if (
                this.serviceLocationStatus == "serviceFrontView" ||
                this.serviceLocationStatus == "serviceAdminView"
              ) {
                this.servicesList = this.applyClientTabFilter(this.serviceResponseArrayModel.ServiceLists.slice());
              }

              if (
                this.serviceResponseArrayModel.ServiceLists &&
                this.serviceResponseArrayModel.ServiceLists.length
              ) {
                this.checkServiceCount.emit(
                  this.serviceResponseArrayModel.ServiceLists.length
                );
              } else {
                this.checkServiceCount.emit(0);
              }
              this.globalService.showLoader = false;
            } else {
              this.globalService.showLoader = false;
              this.serviceResponseArrayModel.ServiceLists =
                ServiceResponseModel[""];
              this.length = 0;
              if (
                this.serviceLocationStatus == "serviceFrontView" ||
                this.serviceLocationStatus == "serviceAdminView"
              ) {
                this.servicesList = [];
              }
              this.checkServiceCount.emit(0);
              // this.globalService.handleApiError(response);
            }
          },
          error => {
            this.globalService.showLoader = false;
            // this.globalService.handleApiError(error);
          }
        );
    } else {
      if (data.serviceLocationStatus == 'serviceManagePage') {
        data.Data = 'serviceManagePage';
        data.ServiceType = this.serviceType;
      }

      this.masterService
        .showServiceListsAdmin(data)
        .pipe(takeUntil(this.globalService.componentDestroyed(this)))
        .subscribe(
          response => {
            if (response.Status) {
              this.globalService.showLoader = false;
              this.thresholdServiceId = response.Data.servicesWithThreshold;
              this.serviceResponseArrayModel = this.globalService.jsonConvert.deserializeObject(
                response.Data,
                ServiceResponseArrayModel
              );
              if (this.serviceLocationStatus == "serviceAdminView" || this.serviceLocationStatus == "serviceFrontView") {
                const rawLists = this.serviceResponseArrayModel.ServiceLists;
                const listSource = Array.isArray(rawLists) ? rawLists : [];
                this.servicesList = this.applyClientTabFilter(listSource.slice());
              }
              if (this.serviceResponseArrayModel.CountLists) {
                this.length = this.serviceResponseArrayModel.CountLists;
              }
              if (
                this.serviceResponseArrayModel.ServiceLists &&
                this.serviceResponseArrayModel.ServiceLists.length
              ) {
                this.checkServiceCount.emit(
                  this.serviceResponseArrayModel.ServiceLists.length
                );
              } else {
                this.checkServiceCount.emit(0);
              }
            } else {
              this.globalService.showLoader = false;
              this.serviceResponseArrayModel.ServiceLists =
                ServiceResponseModel[""];
              this.length = 0;
              if (
                this.serviceLocationStatus == "serviceAdminView" ||
                this.serviceLocationStatus == "serviceFrontView"
              ) {
                this.servicesList = [];
              }
              this.thresholdServiceId = response.Data?.servicesWithThreshold || [];
              this.checkServiceCount.emit(0);
              // this.globalService.handleApiError(response);
            }
          },
          error => {
            this.globalService.showLoader = false;
            this.globalService.handleApiError(error);
          }
        );
    }
  }

  loadCategories(onLoaded?: () => void) {
    this.masterService
      .fetchModuleCategoriesPublic({
        ModuleType: 'service',
        LangKey: this.globalService.getLangAccToUser(),
        Subdomain: window.localStorage.getItem('Subdomain'),
        isCheckedInUser: this.isLoggedIn,
        location: this.serviceLocationStatus === 'serviceFrontView' ? 'front' : this.serviceLocationStatus
      })
      .pipe(takeUntil(this.globalService.componentDestroyed(this)))
      .subscribe(
        response => {
          if (response.Status) {
            this.categories = response.Data.categories || [];
            this.totalServiceCount = response.Data.TotalCount || 0;
            if (
              this.serviceLocationStatus === "serviceFrontView" &&
              !this.guestCategoryFilterTouched &&
              response.Data.DefaultCategoryId
            ) {
              const defaultId = String(response.Data.DefaultCategoryId);
              const inList = (this.categories || []).some(
                (c: any) => String(c._id) === defaultId
              );
              if (inList) {
                this.selectedCategory = defaultId;
              }
            }
          } else {
            this.categories = [];
            this.totalServiceCount = 0;
          }
          if (onLoaded) {
            onLoaded();
          }
        },
        error => {
          this.categories = [];
          this.totalServiceCount = 0;
          if (onLoaded) {
            onLoaded();
          }
        }
      );
  }

  scrollCategoryStrip(direction: number, el: HTMLElement | null | undefined): void {
    if (!el) {
      return;
    }
    const step = Math.min(200, Math.floor(el.clientWidth * 0.75));
    el.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  filterByCategory(categoryId: string | null) {
    if (this.serviceLocationStatus === "serviceFrontView") {
      this.guestCategoryFilterTouched = true;
    }
    this.selectedCategory = categoryId;
    this.pageIndex = 0;
    const fetchList = () => {
      const tabRequest = this.getTabRequestContext();
      this.showServiceLists({
        Data: tabRequest.Data,
        ServiceType: tabRequest.ServiceType,
        InternalService: tabRequest.InternalService,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        categoryId: categoryId
      });
    };
    if (this.serviceLocationStatus === "serviceAdminView") {
      this.refreshAdminServiceTabs(fetchList);
    } else {
      fetchList();
    }
  }

  getCategoryName(category: any): string {
    if (!category || !category.CategoryNames || category.CategoryNames.length === 0) {
      return '';
    }

    const currentLang = this.globalService.getLangAccToUser();
    const resolved = this.globalService.localizedArrayValue(
      category.CategoryNames,
      currentLang
    );
    if (resolved) {
      return resolved;
    }

    return category.CategoryNames[0].Value || '';
  }

  thresholdCheck(id) {
    if (this.thresholdServiceId.length > 0) {
      for (let i = 0; this.thresholdServiceId.length > i; i++) {
        if (this.thresholdServiceId[i].serviceId == id) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  tabChanged(tabChangeEvent) {
    if (this.serviceLocationStatus === "serviceAdminView") {
      const visibleTabs = this.visibleAdminServiceTabIds;
      this.selectedAdminTabId = visibleTabs[tabChangeEvent.index] || visibleTabs[0] || "all";
      this.selectedServiceTabIndex = this.adminTabIndexFromId(this.selectedAdminTabId);
      sessionStorage.setItem(this.serviceAdminTabStorageKey, String(this.selectedServiceTabIndex));
      sessionStorage.removeItem(this.serviceAdminForceTabStorageKey);
    } else {
      this.selectedServiceTabIndex = tabChangeEvent.index;
    }

    this.pageIndex = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    const tabRequest = this.getTabRequestContext();
    this.showServiceLists({
      Data: tabRequest.Data,
      ServiceType: tabRequest.ServiceType,
      InternalService: tabRequest.InternalService,
      Search: this.searchControl?.value || "",
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      isLoggedIn: this.isLoggedIn
    });
  }

  deactivateFromHome(id) {
    let lists = this.serviceResponseArrayModel.ServiceLists;

    let findIndex = lists.findIndex(list => list.id === id);

    this.globalService.showLoader = true;
    this.masterService
      .updateServiceHomeStatus({
        Lang: this.masterService.getLangSaveProperty(),
        Id: id
      })
      .subscribe(
        response => {
          if (response.Status) {
            this.globalService.showLoader = false;
            this.serviceResponseArrayModel.ServiceLists.splice(findIndex, 1);
          } else {
            this.globalService.showLoader = false;
            this.globalService.handleApiError(response);
          }
        },
        error => {
          this.globalService.showLoader = false;
          this.globalService.handleApiError(error);
        }
      );
  }

  getPaginatorData(event: PageEvent) {
    this.currentPageSize = event.pageSize;
    this.pageIndex = event.pageIndex;

    const payload: any = {
      pageIndex: event.pageIndex * event.pageSize,
      pageSize: event.pageSize,
    };

    if (this.serviceLocationStatus === "serviceManagePage") {
      payload.Data = "serviceManagePage";
      payload.ServiceType = this.serviceType;
    } else if (this.serviceLocationStatus === "serviceAdminView") {
      const tabRequest = this.getTabRequestContext();
      payload.Data = tabRequest.Data;
      payload.ServiceType = tabRequest.ServiceType;
      payload.InternalService = tabRequest.InternalService;
      payload.isLoggedIn = this.isLoggedIn;
    } else if (this.serviceLocationStatus === "serviceFrontView") {
      const tabRequest = this.getTabRequestContext();
      payload.Data = tabRequest.Data;
      payload.ServiceType = tabRequest.ServiceType;
      payload.InternalService = tabRequest.InternalService;
      payload.Search = this.searchControl?.value || "";
      payload.isLoggedIn = this.isLoggedIn;
    }

    if (this.selectedCategory) {
      payload.categoryId = this.selectedCategory;
    }

    this.showServiceLists(payload);
  }

  isAdminServiceTabVisible(tabId: AdminServiceTabId): boolean {
    return this.adminTabVisibility[tabId];
  }

  get visibleAdminServiceTabIds(): AdminServiceTabId[] {
    return this.adminServiceTabOrder.filter(tabId => this.adminTabVisibility[tabId]);
  }

  get adminMatTabSelectedIndex(): number {
    const visibleTabs = this.visibleAdminServiceTabIds;
    const index = visibleTabs.indexOf(this.selectedAdminTabId);
    return index >= 0 ? index : 0;
  }

  private adminTabIdFromIndex(index: number): AdminServiceTabId {
    return this.adminServiceTabOrder[Math.max(0, Math.min(this.adminServiceTabOrder.length - 1, index))] || "all";
  }

  private adminTabIndexFromId(tabId: AdminServiceTabId): number {
    const index = this.adminServiceTabOrder.indexOf(tabId);
    return index >= 0 ? index : 0;
  }

  private getAdminTabRequestById(tabId: AdminServiceTabId): {
    Data: string;
    ServiceType?: string;
    InternalService?: boolean;
  } {
    switch (tabId) {
      case "all":
        return { Data: "service-admin-all-services" };
      case "booking":
        return { Data: "service-admin-booking-services", ServiceType: "1" };
      case "maintenance":
        return { Data: "service-admin-maintenance-services", ServiceType: "3" };
      case "internal":
        return {
          Data: "service-admin-internal-services",
          ServiceType: "4",
          InternalService: true
        };
      case "hygiene":
        return { Data: "service-admin-hygiene-services", ServiceType: "5" };
      default:
        return { Data: "serviceAdminView" };
    }
  }

  /**
   * Loads per-tab counts for the current category and hides tabs with zero services.
   */
  private refreshAdminServiceTabs(onComplete?: () => void): void {
    if (this.serviceLocationStatus !== "serviceAdminView") {
      onComplete?.();
      return;
    }

    const requests = this.adminServiceTabOrder.map(tabId => {
      const tabRequest = this.getAdminTabRequestById(tabId);
      // Internal tab: fetch enough rows to count only ShowInternalChecklistInChat === true.
      const pageSize = tabId === "internal" ? 500 : 1;
      const payload: any = {
        Data: tabRequest.Data,
        ServiceType: tabRequest.ServiceType,
        InternalService: tabRequest.InternalService,
        pageIndex: 0,
        pageSize,
        isLoggedIn: this.isLoggedIn,
        serviceLocationStatus: this.serviceLocationStatus
      };
      if (this.selectedCategory) {
        payload.categoryId = this.selectedCategory;
      }

      return this.masterService.showServiceListsAdmin(payload).pipe(
        map(response => {
          let count = 0;
          if (response.Status && response.Data) {
            if (tabId === "internal") {
              const lists = Array.isArray(response.Data.ServiceLists)
                ? response.Data.ServiceLists
                : [];
              count = lists.filter(item =>
                this.isShowInternalChecklistInChatEnabled(
                  item?.ShowInternalChecklistInChat
                )
              ).length;
            } else {
              count = Number(response.Data.CountLists) || 0;
            }
          }
          return { tabId, count };
        })
      );
    });

    forkJoin(requests)
      .pipe(takeUntil(this.globalService.componentDestroyed(this)))
      .subscribe(
        results => {
          results.forEach(({ tabId, count }) => {
            this.adminTabVisibility[tabId] = count > 0;
          });
          this.ensureValidAdminTabSelection();
          onComplete?.();
        },
        () => onComplete?.()
      );
  }

  private ensureValidAdminTabSelection(): void {
    const visibleTabs = this.visibleAdminServiceTabIds;
    if (!visibleTabs.length) {
      return;
    }
    if (!visibleTabs.includes(this.selectedAdminTabId)) {
      this.selectedAdminTabId = visibleTabs[0];
      this.selectedServiceTabIndex = this.adminTabIndexFromId(this.selectedAdminTabId);
      sessionStorage.setItem(this.serviceAdminTabStorageKey, String(this.selectedServiceTabIndex));
    }
  }

  private getTabRequestContext(): {
    Data: string;
    ServiceType?: string;
    InternalService?: boolean;
  } {
    if (this.serviceLocationStatus === "serviceFrontView") {
      if (this.selectedServiceTabIndex === 0) {
        return { Data: "front-booking-services", ServiceType: "1" };
      }
      if (this.selectedServiceTabIndex === 1) {
        return { Data: "front-maintenance-services", ServiceType: "3" };
      }
      if (this.selectedServiceTabIndex === 2) {
        return { Data: "front-information-services", ServiceType: "2" };
      }
      return { Data: "front" };
    }

    if (this.serviceLocationStatus === "serviceAdminView") {
      return this.getAdminTabRequestById(this.selectedAdminTabId);
    }

    return { Data: this.serviceLocationStatus };
  }

  private applyClientTabFilter(list: any[]) {
    if (!list || !list.length) {
      return [];
    }

    if (this.serviceLocationStatus === "serviceFrontView") {
      if (this.selectedServiceTabIndex === 0) {
        return list.filter(item => item.ServiceType == "1" && !item.InternalService);
      }
      if (this.selectedServiceTabIndex === 1) {
        return list.filter(item => item.ServiceType == "3" && !item.InternalService);
      }
      if (this.selectedServiceTabIndex === 2) {
        return list.filter(item => item.ServiceType == "2" && !item.InternalService);
      }
      return list.filter(item => !item.InternalService);
    }

    if (this.serviceLocationStatus === "serviceAdminView") {
      switch (this.selectedAdminTabId) {
        case "all":
          // Hide internal services that are not shown in chat (false / null).
          return list.filter(
            item =>
              !this.isInternalService(item) ||
              this.isShowInternalChecklistInChatEnabled(item?.ShowInternalChecklistInChat)
          );
        case "booking":
          return list.filter(item => item.ServiceType == "1" && !item.InternalService);
        case "maintenance":
          return list.filter(item => item.ServiceType == "3" && !item.InternalService);
        case "internal":
          // Only internal services with ShowInternalChecklistInChat === true (not false/null).
          return list.filter(
            item =>
              !!item.InternalService &&
              this.isShowInternalChecklistInChatEnabled(item?.ShowInternalChecklistInChat)
          );
        case "hygiene":
          return list.filter(item => item.ServiceType == "5" && !item.InternalService);
        default:
          return list;
      }
    }

    return list;
  }

  private parseTabIndex(value: string | null): number | null {
    if (value === null || value === "") {
      return null;
    }

    const parsedValue = Number(value);
    return Number.isNaN(parsedValue) ? null : parsedValue;
  }

  detail(id) {
    this.detailServiceViewEmit.emit(id);
  }

  edit(id) {
    this.editServiceViewEmit.emit(id);
  }

  view(event) {
    this.frontView = "view";
    document.getElementById("listId").classList.remove("active");

    if (!event.currentTarget.classList.contains("active")) {
      event.currentTarget.className =
        "active " + event.currentTarget.attributes.class.value;
    }

    // event.target.offsetParent.firstElementChild.className = "active";
    // if (
    //   event.target.parentElement.parentElement.classList.contains(
    //     "mat-checkbox-checked"
    //   )
    // ) {
    //   event.target.offsetParent.firstElementChild.classList.remove("active");
    // } else {
    //   event.target.offsetParent.firstElementChild.className = "active";
    // }
  }
  list(event) {
    this.frontView = "list";
    document.getElementById("viewId").classList.remove("active");
    if (!event.currentTarget.classList.contains("active")) {
      event.currentTarget.className =
        "active " + event.currentTarget.attributes.class.value;
    }
  }

  


isInternalService(service: any): boolean {
  return Number(service?.ServiceType) === 4 || !!service?.InternalService;
}

isShowInternalChecklistInChatEnabled(value: any): boolean {
  return value === true || value === 'true';
}

isServiceToggleChecked(service: any): boolean {
  if (this.isInternalService(service)) {
    return this.isShowInternalChecklistInChatEnabled(service?.ShowInternalChecklistInChat);
  }
  return !!service?.IsActive;
}

onToggleChange(event: MatSlideToggleChange, id: number, serviceName: string, service?: any) {
   if (!this.canWriteServices()) {
    event.source.checked = !event.checked;
    return;
  }
  // Immediately revert the toggle until confirmation
  event.source.checked = !event.checked;
  this.openDialog(id, serviceName, event.checked, service);
}

openDialog(id: number, serviceName: string, willBeEnabled: boolean, service?: any) {
  const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
    width: '446px',
    panelClass: 'confirmation-modal-popup',
    data: { 
      serviceId: id,
      serviceName: serviceName,
      willBeEnabled: willBeEnabled,
      location: 'service',
      serviceType: service?.ServiceType,
      isInternalService: this.isInternalService(service),
      isActive: service?.IsActive,
    }
  });


  dialogRef.afterClosed().subscribe(result => {
    if (result?.confirmed) {
      // User confirmed the action
      this.updateServiceStatus(result);
    } else {
      // User canceled, reset the toggle
      // this.isToggleChecked = !this.isToggleChecked;
    }
  });
}

// Add this method to handle the service status update
updateServiceStatus(data: any) {
  const isInternalService = data.isInternalService || Number(data.serviceType) === 4;
  const payload: any = {
    ServiceId: data.serviceId,
    Data: {}
  };

  if (isInternalService) {
    payload.Data.IsActive = data.isActive !== false;
    payload.Data.ShowInternalChecklistInChat = data.willBeEnabled ? 'true' : 'false';
  } else {
    payload.Data.IsActive = data.willBeEnabled;
    payload.Data.CommentStatus = !data.willBeEnabled ?
                   (data.reason === 'Other' ? data.otherReason : data.reason) :
                   null;
  }

  this.globalService.showLoader = true;
  this.masterService.updateServiceRestaurantStatus(payload)
    .pipe(takeUntil(this.globalService.componentDestroyed(this)))
    .subscribe(
      (response) => {
        this.globalService.showLoader = false;
        if (response.Status) {
          // Update the service status in your local data
          this.showServiceLists({
            Data: null,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            ServiceType: this.serviceType
          });
          this.updateLocalServiceStatus(data.serviceId, data.willBeEnabled, isInternalService);
          this.globalService.handleSuccessMessage(
            isInternalService
              ? `Show internal checklist in chat ${data.willBeEnabled ? 'enabled' : 'disabled'}`
              : `Service successfully ${data.willBeEnabled ? 'enabled' : 'disabled'}`
          );
        } else {
          this.globalService.handleApiError(response);
        }
      },
      (error) => {
        this.globalService.showLoader = false;
        this.globalService.handleApiError(error);
      }
    );
}
updateLocalServiceStatus(serviceId: number, isEnabled: boolean, isInternalService = false) {
  // Find and update the service in your servicesList or wherever you store it
  const service = this.servicesList.find(s => s.id === serviceId);
  if (service) {
    if (isInternalService) {
      service.ShowInternalChecklistInChat = isEnabled;
      // Dashboard-Service-List only shows chat-enabled internal services.
      if (!isEnabled) {
        this.servicesList = this.servicesList.filter(
          (s: any) => String(s?.id) !== String(serviceId)
        );
        this.length = Math.max(0, (this.length || 0) - 1);
      }
    } else {
      service.IsActive = isEnabled;
    }
  }
}

  private canWriteServices(): boolean {
    if (this.jwtService.getUserRole && this.jwtService.getUserRole() === 'admin') {
      return true;
    }
    try {
      const bulk = JSON.parse(window.localStorage['bulkPermissions'] || 'null');
      const row = Array.isArray(bulk)
        ? bulk.find((item: any) => item?.nameKey === 'services' || item?.NameKey === 'services')
        : null;
      const raw = row?.permissions?.[0] || row?.Permissions?.[0];
      if (!raw) {
        return false;
      }
      return !!(raw.full ?? raw.Full) || !!(raw.manage ?? raw.Manage);
    } catch {
      return false;
    }
  }
}